import React, { useEffect } from "react";
import styled from "styled-components";
import { colors } from "../../../utils/theme";
import { useNavigate } from "react-router-dom";
import { useDataContex } from "../../../hooks/Context/PatientProvider";

const ContainerFormInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }
`;

const FormInputInfo = styled.div`
  width: 35%;
  display: flex;
  margin-bottom: 1rem;
  gap: 20px;
  align-items: center;
  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
  }

  @media (max-width: 1024px) {
    width: 80%;
  }
  label {
    width: 40%;
    color: ${colors.third};
    font-weight: 600;
    @media (max-width: 1024px) {
      text-align: start;
    }
    @media (max-width: 500px) {
      text-align: start;
      width: 100%;
    }
  }

  input {
    width: 80%;
    height: 40px;
    border: 1px solid #d9d9d9;
    padding-left: 10px;
    color: ${colors.fifth};
    @media (max-width: 500px) {
      width: 100%;
    }
    &::placeholder {
      color: ${colors.fifth};
    }
  }

  .identificacion {
    width: 20%;
    color: ${colors.fifth};
    @media (max-width: 500px) {
      width: 20%;
    }
  }

  .id_option {
    width: 90%;
  }

  .ID {
    width: 80%;
    display: flex;
    gap: 20px;

    @media (max-width: 500px) {
      width: 100%;
    }
  }
`;

const handleInputChange = (newValue) => {
  console.log("");
};

const InfoPatientFormContinuidad = () => {


  const { patientContinuidadContex } =
  useDataContex();

  const patient = patientContinuidadContex;




  return (
    <div>
      <ContainerFormInfo>
        <FormInputInfo>
          <label>DOCUMENTO ID: </label>
          <div className="ID">
            <input
              className="identificacion"
              type="text"
              readOnly
              value={"CC"}
              onChange={(e) => handleInputChange(e.target.value)}
            />
            <input
              className="id_option"
              type="text"
              readOnly
              value={patient?.numeroDocumento}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </div>
        </FormInputInfo>

        <FormInputInfo>
          <label>EMAIL</label>
          <input
            type="text"
            readOnly
            value={patient?.email}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>
        <FormInputInfo>
          <label>NOMBRE</label>
          <input
            type="text"
            readOnly
            value={patient?.name}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>TELÉFONO MOVIL</label>
          <input
            type="text"
            readOnly
            value={patient?.telefono}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>F. NACIMIENTO</label>
          <input
            type="text"
            readOnly
            value={patient?.fechaNacimiento}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>
      </ContainerFormInfo>
    </div>
  );
};

export default InfoPatientFormContinuidad;
